@if (loading()) {
    <div class="modal-spinner" @fadeIn @fadeOut>
        <div loading-icon class="text-center"></div>
        <!-- <div class="lds-ripple"><div></div><div></div></div> -->
    </div>
}